import type { BrandName } from '@/scopes/common/domain/types'

function isElizaBrand(brandName: BrandName): boolean {
  return brandName === 'eliza'
}

export function shouldShowTrustIcons(brandName: BrandName): boolean {
  return isElizaBrand(brandName)
}
